import { Theme } from '../../../../jss';

export const BlogsPostCardClassBase = (theme: Theme) => {
  return {
    '& .blog-post-card-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      height: 'auto',
      borderBottom: `1px solid ${theme.palette.mainBackgroundColor}`,
      fontFamily: theme.typography.ancillaryFontFamily,
      fontWeight: '300',
      color: theme.palette.ancillaryFontColor,
      paddingBottom: '1.25rem',
      marginBottom: '0.75rem',
      cursor: 'pointer',
      '@media (min-width: 640px)': {
        height: '600px',
        minHeight: '50vh',
      },

      '& p': {
        lineHeight: '1.25rem',
        height: 'auto',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '@media (min-width: 640px)': {
          height: '30vh',
          minHeight: '20vh',
        },
      },
      textOverflow: 'ellipsis',
    },
    '& .blog-post-card-img-container': {
      position: 'relative',
      width: '100%',
    },
    '& .blog-post-img': {
      width: '100%',
      height: '320px',
      cursor: 'pointer',
      borderBottom: `1px solid ${theme.palette.mainBackgroundColor}`,
    },
    '& .blog-card-img-label': {
      fontFamily: 'SourceSansPro,Helvetica,Arial,sans-serif',
      fontSize: '.93rem',
      textTransform: 'uppercase',
      marginBottom: '12px',
    },
    '& .card-description': {
      fontFamily: theme.typography.mainFontFamily,
      width: '100%',
    },
    '& .blog-card-title': {
      fontFamily: theme.typography.mainFontFamilyMedium,
      fontSize: `${theme.sizing.fontS}rem`,
      fontWeight: '700',
      marginTop: '0.75rem',
      marginBottom: '1.25rem',
      lineHeight: '1rem',
    },
    '& .blog-post-card-read-more': {
      marginTop: '10px',
      '@media (min-width: 640px)': {
        display: 'none',
      },
    },
  };
};
